import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  buttonLink: {
    margin: theme.spacing(5, 0),
  },
  toggleButtonMargin: {
    margin: theme.spacing(5, 4),
  },
  gridMargin: {
    marginLeft: 15,
  },
  searchStyles: {
    margin: theme.spacing(5, 2, 2, 4),
    overflow: 'hidden',
  },
  inputStyles: {
    height: 36,
    borderRadius: 25,
  },
  iconButtonStyle: {
    textTransform: 'none',
    '&:focus': {
      outline: '0 !important',
      border: '0 !important',
      boxShadow: 'none !important',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  searchColor: {
    color: '#bdbdbd',
  },
}))

export default useStyles
